import { render, staticRenderFns } from "./newFeaturedSponsorEdition.vue?vue&type=template&id=6292e7b4"
import script from "./newFeaturedSponsorEdition.vue?vue&type=script&lang=js"
export * from "./newFeaturedSponsorEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports